<div [ngClass]="{'disabled': disableYoutubeExport || mediaclip.status === 'draft'}" class="button" (click)="exportToYouTube = !exportToYouTube"><i class="fa fa-share-square-o"></i>{{ 'EXPORT_TO_YOUTUBE' | translate }}</div>
<div [ngClass]="{'disabled': mediaclip.status === 'draft'}" class="button" (click)="exportToFacebook = !exportToFacebook"><i class="fa fa-share-square-o"></i>{{ 'EXPORT_TO_FACEBOOK_CHANNEL' | translate }}</div>
<div [ngClass]="{'disabled': mediaclip.status === 'draft'}" class="button" (click)="exportToInstagram = !exportToInstagram"><i class="fa fa-share-square-o"></i>{{ 'EXPORT_TO_INSTAGRAM_CHANNEL' | translate }}</div>

<p *ngIf="mediaclip.status === 'draft'"><small>{{ 'EXPORT_UNAVAILABLE_FOR_DRAFT_CLIPS' | translate }}</small></p>

<div class="container">
	<!-- New Facebook export -->
	<div *ngIf="exportToFacebook">
		<h2>{{ 'EXPORT_TO_FACEBOOK_CHANNEL' | translate }}</h2>
		<div class="start-export">
			<div class="label">{{ 'SOCIAL_CHANNEL' | translate }}</div>
			<div class="exportSettings">
				<bb-entity-selector 
					[(ngModel)]="facebookPage" 
					[options]="exportChannel.facebook"
					(ngModelChange)="onChannelSelected($event)">
				</bb-entity-selector>
				<div class="buttons">
					<span class="button" (click)="exportToFacebook = !exportToFacebook"><i class="fa fa-times"></i>{{ 'CANCEL' | translate }}</span>
					<span class="button" (click)="exportToChannel(facebookPage, 'facebook')" [ngClass]="{'disabled': !channelIsAuthenticated}"><i class="fa fa-share-square-o"></i>{{ 'EXPORT' | translate }}</span>
				</div>
			</div>
		</div>
	</div>

	<!-- New Instagram export -->
	<div *ngIf="(exportToInstagram) && instagramSupported" class="youtube-export-header">
		<h2>{{ 'EXPORT_TO_INSTAGRAM_CHANNEL' | translate }}</h2>
		<a [href]="mediaclip.url">{{ mediaclip.url }}</a>
		<div class="start-export">
			<div class="label">{{ 'SOCIAL_CHANNEL' | translate }}</div>
			<div class="exportSettings">
				<bb-entity-selector 
					[(ngModel)]="instagramPage" 
					[options]="exportChannel.instagram"
					(ngModelChange)="onChannelSelected($event)">
				</bb-entity-selector>
				<div class="buttons">
					<span class="button" (click)="exportToInstagram = !exportToInstagram"><i class="fa fa-times"></i>{{ 'CANCEL' | translate }}</span>
					<span class="button" (click)="exportToChannel(instagramPage, 'instagram')" [ngClass]="{'disabled': !channelIsAuthenticated}"><i class="fa fa-share-square-o"></i>{{ 'EXPORT' | translate }}</span>
				</div>
			</div>
		</div>
	</div>

	<div class="youtube-export-header" *ngIf="(exportToInstagram) && !instagramSupported">
		<span class="message warning ng-binding"> 
			<i class="fa fa-warning" ></i>{{ 'INSTAGRAM_CANNOT_EXPORT' | translate: { message: instagramReason } }}
		</span>
	</div>

	<div class="export-container" *ngIf="youtubeExported && !youtubeExportError">
		<div class="youtube-header">
			<h3>
				<i class="fa-brands fa-youtube"></i>
				<a *ngIf="mediaclip?.YouTube_id && mediaclip?.YouTube_id !== 'uploading'" target="_blank" [href]="'https://www.youtube.com/watch?v=' + mediaclip?.YouTube_id">{{ 'https://www.youtube.com/watch?v=' + mediaclip?.YouTube_id }}</a>
				<span *ngIf="mediaclip?.YouTube_id === 'uploading'">{{ 'UPLOADING' | translate }}...</span>
			</h3>
			<span class="button" [ngClass]="{'disabled': mediaclip?.YouTube_id === 'uploading'}" (click)="deleteFromChannel(youtubeChannel)"><i class="fa fa-trash"></i>{{ 'DELETE' | translate }}</span>
		</div>
		<div class="details youtube">

			<div class="info">
				<div class="label">
					<div>{{ 'EXPORTED' | translate }}</div>
					<div *ngIf="mediaclip?.YouTube_id && mediaclip?.YouTube_id !== 'uploading'" [title]="mediaclip?.YouTube_published_date | bbDate">{{ mediaclip?.YouTube_published_date | bbDate:'relative' }}</div>
				</div>
				<div class="label">
					<div>{{ 'YOUTUBE_ID' | translate }}</div>
					<div *ngIf="mediaclip?.YouTube_id && mediaclip?.YouTube_id !== 'uploading'">{{ mediaclip?.YouTube_id }}</div>
				</div>
				<div class="label">
					<div>{{ 'CHANNEL' | translate }}</div>
					<div class="overflow"><a target="_blank" [href]="exportChannelDetails?.remoteUrl">{{ exportChannelDetails?.name | titlecase }}</a></div>
				</div>
				<div class="label">
					<div>{{ 'STATISTICS_UPDATED' | translate }}</div>
					<div *ngIf="mediaclip?.YouTube_id && mediaclip?.YouTube_id !== 'uploading'" [title]="exportedStats?.updatedDate | bbDate">{{ exportedStats?.updatedDate | bbDate:'relative' }}</div>
				</div>
				<div *ngIf="hasAutoCaptionsFromExport" class="label">
					<div>{{ 'AUTO_CAPTIONS' | translate }}</div>
					<div *ngIf="mediaclip?.YouTube_id && mediaclip?.YouTube_id !== 'uploading'">{{ hasAutoCaptionsFromExport }}</div>
				</div>
			</div>

			<div class="stats">
				<ng-container *ngIf="mediaclip?.YouTube_id && mediaclip?.YouTube_id !== 'uploading'">
					<div><i class="fa fa-eye"></i> {{ exportedStats?.viewCount }}</div>
					<div><i class="fa fa-thumbs-up"></i> {{ exportedStats?.likeCount }}</div>
					<div><i class="fa fa-thumbs-down"></i> {{ exportedStats?.dislikeCount }}</div>
					<div><i class="fa fa-comments-o"></i> {{ exportedStats?.commentCount }}</div>
				</ng-container>
			</div>
			<div class="logo" [ngStyle]="{'background': exportChannelDetails?.remoteBannerImageUrl ? '#000 url(' + exportChannelDetails?.remoteBannerImageUrl + ') repeat 0 0' : ''}">
				<img *ngIf="exportChannelDetails?.remoteLogoImageUrl" [src]="exportChannelDetails?.remoteLogoImageUrl">
				<p>{{ exportChannelDetails?.name | titlecase }} <span [routerLink]="['/library/social/youtube/', exportChannelDetails?.id, 'settings']"><i class="fa fa-pencil-square-o"></i></span></p>
			</div>
		</div>
		<div class="tablet">
			<span class="button" [ngClass]="{'disabled': mediaclip?.YouTube_id === 'uploading'}" (click)="deleteFromChannel(youtubeChannel)"><i class="fa fa-trash"></i>{{ 'DELETE' | translate }}</span>
		</div>
	</div>

	<!-- Facebook container, showing already exported -->
	<div class="export-container" *ngIf="facebookExported && !facebookExportError">
		<ng-container *ngFor="let exports of facebookExportDetails; let i = index;">
			<div class="facebook-header">
				<h3>
					<i class="fa-brands fa-facebook"></i>
					<a target="_blank" [href]="exports.exportchannel.remoteUrl">{{ exports.exportchannel.remotePageTitle }}</a>
				</h3>
				</div>
			<div class="details ">
				<div class="info">
					<div class="label">
						<div>{{ 'EXPORT_ID' | translate }}</div>
						<div >{{ exports.externalid }}</div>
					</div>
					<div class="label">
						<div>{{ 'URL' | translate }}</div>
						<div class="overflow"><a target="_blank" [href]="exports.exportchannel?.remoteUrl">{{ exports.exportchannel?.remoteUrl }}</a></div>
					</div>
				</div>

				<div class="stats">
					<div><i class="fa fa-eye"></i> {{ exports.stats?.viewCount }}</div>
					<div><i class="fa fa-thumbs-up"></i> {{ exports.stats?.likeCount }}</div>
					<div><i class="fa fa-comments-o"></i> {{ exports.stats?.commentCount }}</div>
				</div>
			</div>
		</ng-container>
	</div>

	<!-- Instagram container, showing already exported -->
	<div class="export-container" *ngIf="instagramExported && !instagramExportedError">
		<ng-container *ngFor="let exports of instagramExportDetails; let i = index;">
			<div class="facebook-header">
				<h3>
					<i class="fa-brands fa-instagram"></i>
					<a target="_blank" [href]="exports.exportchannel.remoteUrl">{{ exports.exportchannel.remotePageTitle }}</a>
				</h3>
				</div>
			<div class="details">
				<div class="info">
					<div class="label">
						<div>{{ 'EXPORT_ID' | translate }}</div>
						<div>{{ exports.externalid }}</div>
					</div>
					<div class="label">
						<div>{{ 'URL' | translate }}</div>
						<div class="overflow"><a target="_blank" [href]="exports.exportchannel?.remoteUrl">{{ exports.exportchannel?.remoteUrl }}</a></div>
					</div>
				</div>
				<div *ngIf="exports.externalid" class="stats">
					<div><i class="fa fa-eye"></i> {{ exports.stats?.viewCount }}</div>
					<div><i class="fa fa-thumbs-up"></i> {{ exports.stats?.likeCount }}</div>
					<div><i class="fa fa-comments-o"></i> {{ exports.stats?.commentCount }}</div>
				</div>
			</div>
		</ng-container>
	</div>

	<div class="disclaimer" *ngIf="(instagramExported && !instagramExportedError) || (facebookExported && !facebookExportError)">
		<span class="message info ng-binding"> 
			<i class="fa-solid fa-circle-info"></i>{{ 'HELP.SOCIAL_METRICS_DELAY' | translate }}
		</span>
	</div>

	<div *ngIf="(!youtubeExported && exportToYouTube)" class="youtube-export-header">
		<h2>{{ 'YOUTUBE_SYNCHRONISATION' | translate }}</h2>
		<div class="start-export">
			<div class="label">{{ 'SOCIAL_CHANNEL' | translate }}</div>
			<div class="exportSettings">
				<bb-entity-selector 
					[(ngModel)]="youtubeChannel" 
					[options]="exportChannel.youtube"
					(ngModelChange)="onChannelSelected($event)">
				</bb-entity-selector>
				<div class="buttons">
					<span class="button" (click)="exportToYouTube = !exportToYouTube"><i class="fa fa-times"></i>{{ 'CANCEL' | translate }}</span>
					<span class="button" (click)="exportToChannel(youtubeChannel, false)" [ngClass]="{'disabled': !channelIsAuthenticated}"><i class="fa fa-share-square-o"></i>{{ 'EXPORT' | translate }}</span>
				</div>
			</div>
		</div>
		<div class="custom-warning">
			<span *ngIf="channelSelected && channelQuotaExceeded" class="message warning ng-binding">
				<i class="fa fa-warning" ></i>{{ resumeDate | timeRemaining }}
			</span>
			<span *ngIf="channelSelected && !channelIsAuthenticated && !channelQuotaExceeded" class="message warning ng-binding">
				<i class="fa fa-warning" ></i>{{ 'HELP.CHANNEL_NOT_AUTHENTICATED' | translate }}<a [routerLink]="['/library/social/', youtubeChannel, 'general']">{{ 'SOCIAL_CHANNEL' | translate }}</a>.
			</span>
		</div>
	</div>

</div>

<div class="container">
	<div class="export-container" *ngIf="mediaclip?.youtubeImportId">
		<h2 *ngIf="importSource"><i class="fa fa-{{ icon }}" aria-hidden="true"></i> {{ importSource }} {{ 'IMPORT_INFORMATION' | translate | lowercase }}</h2>
		<h2 *ngIf="!importSource"><i class="fa fa-cloud-download" aria-hidden="true"></i>{{ 'IMPORT_INFORMATION' | translate }}</h2>

		<div class="line">
			<label>{{ 'IMPORT_ID' | translate }}</label>
			<span>{{ mediaclip?.youtubeImportId }}</span>
		</div>
		<div class="line">
			<label>{{ 'IMPORT_URL' | translate }}</label>
			<a [href]="importUrl" target="_blank">{{ importUrl }}</a>
		</div>
		<div *ngIf="hasAutoCaptionsFromImport" class="line">
			<label>{{ 'AUTO_CAPTIONS' | translate }}</label>
			<span>
				{{ hasAutoCaptionsFromImport }}
			</span>
		</div>
	</div>
</div>
